import type { FaireProductEntity } from "../../entity_types/product";

export const p_dd68kr2wxb: FaireProductEntity = {
  token: "p_dd68kr2wxb",
  type: "product",
  name: "Sunday Sauce Catch-all Tray",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/8f58b6edd03d552239e6ab8f6445051e37fc2d2f21dab4e9ee473f749179fca6.png",
  galleryImageUrls: [],
  priceDollars: 8,
  description: "A vibrant metal tray perfect for trinkets, snacks, and more inspired by your favorite tomato can!\n\nA catch all for your desk and a perfect way to proudly display your tomato sticky notes and food themed accessories. \n\nGood to know:\n-Measures 7\"x5.5\"\n-Durable metal tray\n-Food safe!\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:00.486Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
